import { StarterCallback } from "@/starter";
import { bindHttpClients, HttpError } from "@/http/lib";
import { forEachHttpClient } from "@/http/lib/utils";
import { clients, manager } from "@/http/clients";

const httpClients = bindHttpClients(manager, clients);

const initHttpClient: StarterCallback = (app) => {
  manager.setVueInstance(app);
  forEachHttpClient(clients, (client) => {
    client.setVueInstance(app);
  });
  app.use(httpClients);
};

const useClient = () => {
  return httpClients.clients;
};

export { initHttpClient, useClient, HttpError };
